async function parseJson(response: Response) {
  return response.json().catch(() => null);
}

function extractErrorMessage(payload: any, fallback: string) {
  return payload?.error?.message || payload?.error || fallback;
}

export async function getActivePartConfiguration() {
  const response = await fetch("/api/v1/parts-config", {
    method: "GET",
  });

  const payload = await parseJson(response);
  if (!response.ok) {
    const error = new Error(extractErrorMessage(payload, "Failed to fetch part configuration")) as Error & {
      status?: number;
    };
    error.status = response.status;
    throw error;
  }

  return payload?.data || null;
}

export async function updatePartConfiguration(code: string) {
  const response = await fetch("/api/v1/parts-config", {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });

  const payload = await parseJson(response);
  if (!response.ok) {
    return {
      error: extractErrorMessage(payload, "Failed to update part configuration"),
      details: payload?.error?.details || payload?.error || null,
    };
  }

  return payload?.data;
}
